
import React from 'react';
import { renderFilePreview } from '@/utils/fileUtils';
import ChatHeader from './chat/ChatHeader';
import ChatMessages from './chat/ChatMessages';
import ChatControls from './chat/ChatControls';
import { useChat } from '@/hooks/useChat';
import { clearChatHistory } from '@/utils/cookieUtils';
import { useToast } from '@/hooks/use-toast';

const ChatInterface = () => {
  const {
    messages,
    setMessages,
    inputMessage,
    setInputMessage,
    isTyping,
    uploadedFiles,
    setUploadedFiles,
    isUploading,
    setIsUploading,
    hasUserSentMessage,
    setHasUserSentMessage,
    handleSendMessage
  } = useChat();

  const { toast } = useToast();

  const clearConversation = () => {
    // Clear chat history in cookies
    clearChatHistory();
    
    // Immediately clear the UI state
    setMessages([]);
    setHasUserSentMessage(false);
    
    toast({
      title: "Conversation cleared",
      description: "Your chat history has been cleared.",
      variant: "default"
    });
  };

  const handlePromptClick = async (prompt: string) => {
    if (!prompt.trim()) return;
    handleSendMessage(prompt);
  };

  return (
    <div className="flex flex-col fixed inset-0 z-50 bg-gradient-to-b from-knightblack to-deepshadow">
      <ChatHeader isExpanded={true} onClearChat={clearConversation} />
      
      <ChatMessages 
        messages={messages} 
        isTyping={isTyping} 
        renderFilePreview={renderFilePreview}
        isExpanded={true}
        hasUserSentMessage={hasUserSentMessage}
        onPromptClick={handlePromptClick}
      />
      
      <ChatControls 
        inputMessage={inputMessage}
        setInputMessage={setInputMessage}
        handleSendMessage={handleSendMessage}
        uploadedFiles={uploadedFiles}
        onRemoveFile={(index) => {
          setUploadedFiles(prev => prev.filter((_, i) => i !== index));
        }}
        isUploading={isUploading}
        setIsUploading={setIsUploading}
        setUploadedFiles={setUploadedFiles}
        renderFilePreview={renderFilePreview}
        showSuggestions={!hasUserSentMessage}
        onPromptClick={handlePromptClick}
      />
    </div>
  );
};

export default ChatInterface;
